// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-dce3efa8] .el-table__header img{margin-top:-4px}[data-v-dce3efa8] .el-table__header tr th{background:#fafaf9;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}[data-v-dce3efa8] .el-table__header th .cell{padding-right:14px}[data-v-dce3efa8] .el-table__header th .cell .el-checkbox{margin-left:0}.bottom_page[data-v-dce3efa8]{text-align:right}.el-table th.star>.cell[data-v-dce3efa8]:before{content:\"*\";color:#ff1818}", ""]);
// Exports
module.exports = exports;
